// Catálogo de eventos internos de auditoría — docs/06 §8 (nombres exactos del doc).
// Se añaden los eventos CRUD que el doc implica pero no enumera (updated/deleted de
// scopes, roles, nodos, clients, app keys y webhooks; reset de contraseña; activación
// de dominio) para que ningún módulo tenga que tocar shared después del freeze.
export const AUDIT_EVENTS = [
  // Ciclo de autenticación y sesión
  "auth.login.success",
  "auth.login.failed",
  "auth.logout",
  "auth.refresh.rotated",
  "auth.refresh.reused",
  "auth.account.locked",
  "auth.account.unlocked",
  "auth.mfa.enabled",
  "auth.mfa.disabled",
  "auth.mfa.failed",
  // Gestión de usuarios (`registered` = alta self-service vía API)
  "user.created",
  "user.registered",
  "user.updated",
  "user.deleted",
  "user.purged",
  "user.password.changed",
  "user.password.reset_requested",
  "user.password.set_by_admin",
  "user.password.reset_completed",
  "user.roles.changed",
  // Tenants secundarios (dominios que el usuario puede mirar además del suyo).
  "user.domain_access.changed",
  // Scopes DIRECTOS (además de los de sus roles) y jaula de vehículos/grupos.
  "user.scopes.changed",
  "user.vehicle_access.changed",
  // «Ver como»: un administrador abrió una sesión a nombre de otro usuario.
  "user.impersonated",
  // Ciclo del perfil self-service
  "user.profile.updated",
  "user.email.change_requested",
  "user.email.change_confirmed",
  // Dominios
  "domain.created",
  "domain.updated",
  "domain.suspended",
  "domain.activated",
  "domain.master.transferred",
  // Autorización
  "scope.created",
  "scope.updated",
  "scope.deleted",
  "role.created",
  "role.updated",
  "role.deleted",
  "role.scopes.changed",
  // Topología y sharding
  "node.registered",
  "node.updated",
  "node.deleted",
  "node.status.changed",
  "node.down",
  "shard.assigned",
  "shard.reassigned",
  // Clients M2M y API keys de app
  "client.created",
  "client.updated",
  "client.deleted",
  "client.secret.rotated",
  "app_key.created",
  "app_key.updated",
  "app_key.revoked",
  // Claves de firma
  "key.rotated",
  "key.retired",
  // Configuración (con diff en `data`)
  "branding.updated",
  "settings.updated",
  // Webhooks (disabled = deshabilitado tras 50 fallos consecutivos)
  "webhook.created",
  "webhook.updated",
  "webhook.deleted",
  "webhook.disabled",
  // Flota (vehículos = fuente de verdad en seguridad; devices viven en el gateway)
  "vehicle.created",
  "vehicle.updated",
  "vehicle.deleted",
  "vehicle.purged",
  "vehicle.devices.changed",
  // Reglas de alarma por vehículo (fuente de verdad aquí; los nodos solo las aplican).
  "alarm_rule.created",
  "alarm_rule.updated",
  "alarm_rule.deleted",
  "alarm_rule.targets_set",
  // Reportes programados (definición en auth; el worker los genera y envía).
  "scheduled_report.created",
  "scheduled_report.updated",
  "scheduled_report.deleted",
  "scheduled_report.run_requested",
  "vehicle_group.created",
  "vehicle_group.updated",
  "vehicle_group.deleted",
] as const

export type AuditEventName = (typeof AUDIT_EVENTS)[number]

// Los eventos externos de la app usan namespace obligatorio `app.*` — docs/04 §2.
export const APP_EVENT_PREFIX = "app."

// Notación punto con segmentos [a-z0-9_-]; ej. `app.device.rebooted`.
export const APP_EVENT_REGEX = /^app\.[a-z0-9_-]+(\.[a-z0-9_-]+)*$/

export type AppEventName = `app.${string}`

export const isAppEvent = (event: string): event is AppEventName => APP_EVENT_REGEX.test(event)
